import React from 'react';
// import { FileExcel } from 'styled-icons/bootstrap';
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';

function ExportExcel(props) {
  const { studentsDataSet } = props;

  const [data, setData] = React.useState({});

  const exporter = React.useRef();

  const exportExcelFunction = () => {
    if (exporter.current) {
      exporter.current.save();
    }
  };

  React.useEffect(() => {
    const temp = (studentsDataSet || []).reduce((acc, element) => {
      const data = { ...element };
      data.career = element.career === '-----' ? 'No definido' : element.career;
      data.phoneNumber = element.phoneNumber === '-----' ? 'No definido' : element.phoneNumber;
      acc.push(data);
      return acc;
    }, []);
    setData(temp);
  }, [studentsDataSet]);

  return (
    <>
      <button type="button" className="k-button k-primary" onClick={exportExcelFunction}>
        Exportar a Excel
      </button>
      <ExcelExport data={data} fileName="TotalEstudiantes.xlsx" ref={exporter}>
        <ExcelExportColumn title="ID o Matricula" field="scholarID" />
        <ExcelExportColumn title="Nombre" field="names" />
        <ExcelExportColumn title="Apellidos" field="lastNames" />
        <ExcelExportColumn title="Correo electrónico" field="email" />
        <ExcelExportColumn title="Tipo de usuario" field="userType" />
        <ExcelExportColumn title="Pregunta de validacion" field="currentQuestion" />
        <ExcelExportColumn title="Respuesta" field="question" />
        <ExcelExportColumn title="Carrera" field="career" />
        <ExcelExportColumn title="Teléfono" field="phoneNumber" />
      </ExcelExport>
    </>
  );
}

export default ExportExcel;
